import { STREAM_PRIVACY_MASK_SCREENSHOT } from '../config/streamPrivacy';
import { drawStreamPrivacyMask } from './drawStreamPrivacyMask';

/**
 * Przy streamie cross-origin bez CORS na elemencie video `canvas.toBlob` może się nie udać (polityka przeglądarki).
 */
export function captureVideoFrameWithLogo(video, logoUrl, { maskAlreadyApplied = false } = {}) {
    return new Promise((resolve, reject) => {
        const w = video.videoWidth;
        const h = video.videoHeight;
        if (!w || !h) {
            reject(new Error('Brak klatki — poczekaj aż obraz się załaduje.'));
            return;
        }

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            reject(new Error('Canvas niedostępny'));
            return;
        }

        try {
            ctx.drawImage(video, 0, 0, w, h);
            if (!maskAlreadyApplied) {
                drawStreamPrivacyMask(ctx, canvas, w, h, STREAM_PRIVACY_MASK_SCREENSHOT, {
                    videoEl: video,
                });
            }
        } catch (e) {
            reject(e);
            return;
        }

        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
            const pad = Math.max(8, Math.round(Math.min(w, h) * 0.018));
            const maxLogoW = Math.round(w * 0.12);
            let lw = img.naturalWidth;
            let lh = img.naturalHeight;
            const scale = maxLogoW / lw;
            lw *= scale;
            lh *= scale;
            ctx.drawImage(img, w - lw - pad, h - lh - pad, lw, lh);

            try {
                canvas.toBlob(
                    (blob) => {
                        if (blob) resolve(blob);
                        else reject(new Error('Nie udało się utworzyć pliku PNG'));
                    },
                    'image/png',
                    0.95
                );
            } catch (e) {
                reject(e);
            }
        };
        img.onerror = () => reject(new Error('Nie udało się wczytać logo'));
        img.src = logoUrl;
    });
}

export function downloadPngBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}

export function screenshotFilename() {
    const t = new Date();
    const y = t.getFullYear();
    const mo = String(t.getMonth() + 1).padStart(2, '0');
    const d = String(t.getDate()).padStart(2, '0');
    const h = String(t.getHours()).padStart(2, '0');
    const mi = String(t.getMinutes()).padStart(2, '0');
    const s = String(t.getSeconds()).padStart(2, '0');
    return `bociany-zywocice-${y}-${mo}-${d}-${h}-${mi}-${s}.png`;
}
